import { render, staticRenderFns } from "./AssetAssignment.vue?vue&type=template&id=6f0d556b"
import script from "./AssetAssignment.vue?vue&type=script&lang=js"
export * from "./AssetAssignment.vue?vue&type=script&lang=js"
import style0 from "./AssetAssignment.vue?vue&type=style&index=0&id=6f0d556b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports